export function formatDate(date: Date) {
  return date.toISOString().split('T')[0];
}

export function getCurrentDateWithoutTime(): Date {
  return new Date(formatDate(new Date()));
}

export function addDaysToDate(date: Date, days: number) {
  date.setDate(date.getDate() + days);
  return date;
}
